import { Observable, of, SchedulerLike } from 'rxjs';
import { Injectable, InjectionToken } from '@angular/core';

export class SalesTeamInterface {
  teamName?: string;
  groupId?: string;
  partnerId?: string;
  marketId?: string;
  updated?: Date;
}

export interface SalesTeamsServiceInterface {
  getSalesTeams$(partnerId: string, marketId: string, scheduler?: SchedulerLike): Observable<SalesTeamInterface[]>;
  listSalesTeamMembers(groupId: string): Observable<string[]>;
}

export const SalesTeamsServiceInterfaceToken: InjectionToken<SalesTeamsServiceInterface> =
  new InjectionToken<SalesTeamsServiceInterface>('SalesTeamsServiceInterface');

@Injectable()
export class SalesTeamsServiceInterfaceStub implements SalesTeamsServiceInterface {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getSalesTeams$(partnerId: string, marketId: string, scheduler?: SchedulerLike): Observable<SalesTeamInterface[]> {
    return of([
      {
        teamName: 'The Best Sales Team',
        groupId: 'g-1234',
        partnerId: 'ABC',
        marketId: 'mk1',
      },
    ]);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  listSalesTeamMembers(groupId: string): Observable<string[]> {
    return of(['SP-1', 'SP-2']);
  }
}
